import { render, staticRenderFns } from "./MyResult.vue?vue&type=template&id=0f4f48fe&scoped=true&"
import script from "./MyResult.vue?vue&type=script&lang=js&"
export * from "./MyResult.vue?vue&type=script&lang=js&"
import style0 from "./MyResult.vue?vue&type=style&index=0&id=0f4f48fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4f48fe",
  null
  
)

export default component.exports